import Vue from 'vue'
import App from './App.vue'
import router from './router' 
import vuetify from './plugins/vuetify';
import './plugins/others';
import './plugins/firebase'
import './plugins/customerComponents' 
import './plugins/main.css'
import { store } from './store' 
import {EventBus} from './plugins/eventBus'
import XLSX from "xlsx"

Vue.config.productionTip = false
Vue.mixin({
  data() {
    return {
      EventBus: EventBus,
      XLSX:XLSX
    }
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
